<app-start [showLoadingIndicator]="true"></app-start>
<app-footer></app-footer>
